import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "flowbite-react";
import { IoMdClose } from "react-icons/io";
import "./ModalAlert.scss";

// eslint-disable-next-line react-refresh/only-export-components
export enum TYPE_ALERT {
  NORMAL = "NORMAL",
  PRICE = "PRICE",
}

type Props = {
  type?: TYPE_ALERT;
  handleClose: () => void;
};

const ModalAlert: React.FC<Props> = ({ type, handleClose }) => {
  const [city, setCity] = useState<string | null>(null);

  const readCityFromStorage = useCallback(() => {
    try {
      if (typeof window === "undefined") return;
      const raw = localStorage.getItem("selectedCompanies");
      if (!raw) return;

      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length > 0) {
        setCity(parsed[0]?.city ?? null);
      }
    } catch {
      setCity(null);
    }
  }, []);

  useEffect(() => {
    if (type) readCityFromStorage();
  }, [type, readCityFromStorage]);

  const send = () => {
    const button = document.getElementById("buttonSend") as
      | HTMLButtonElement
      | null;
    button?.click();
  };

  return (
    <Modal show={!!type} onClose={handleClose} className="modal-alert">
      <div className="modal-alert__container">
        <button
          type="button"
          className="modal-alert__close-btn"
          aria-label="Fechar"
          onClick={handleClose}
        >
          <IoMdClose size={24} />
        </button>

        <Modal.Body className="bodyContainerAlert">
          {type === TYPE_ALERT.NORMAL && (
            <div className="containerAlert containerAlert-normal">
              <h2 className="text-redPrimary">Alerta</h2>
              <p>
                A compra está sendo realizada para a filial:{" "}
                <strong>{city ?? "—"}</strong>
              </p>
              <span>
                Tem certeza que deseja{" "}
                <span className="text-redPrimary">CONTINUAR ?</span>
              </span>
              <button onClick={send}>SIM</button>
            </div>
          )}

          {type === TYPE_ALERT.PRICE && (
            <div className="containerAlert containerAlert-price">
              <h2 className="text-redPrimary">Alerta</h2>
              <p>
                O preço atual do item está 30% divergente em relação à última
                compra.
              </p>
              <span>
                Tem certeza que deseja{" "}
                <span className="text-redPrimary">CONTINUAR ?</span>
              </span>
              <button onClick={send}>SIM</button>
            </div>
          )}
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default ModalAlert;
